module.exports = __webpack_public_path__ + "static/media/poster.2ebd0da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/poster.png
// module id = 995
// module chunks = 0